export var getBPersonAccountIdMap = function () {
    try {
        var storagePersonAccountIdMap = localStorage.getItem('person-account-wedriveUin-tinyid-map') || '{}';
        var personAccountIdMap = JSON.parse(storagePersonAccountIdMap);
        return personAccountIdMap;
    }
    catch (err) {
        console.error(err);
        return {};
    }
};
// b端登录态里不存储tinyid，但是session_list里c端账号需要使用tinyid，所以在登录c端账号时缓存一下tinyid
export var setBPersonAccountIdMap = function (_a) {
    var wedriveUin = _a.wedriveUin, tinyid = _a.tinyid;
    try {
        var storagePersonAccountIdMap = localStorage.getItem('person-account-wedriveUin-tinyid-map') || '{}';
        var personAccountIdMap = JSON.parse(storagePersonAccountIdMap);
        personAccountIdMap[wedriveUin] = tinyid;
        localStorage.setItem('person-account-wedriveUin-tinyid-map', personAccountIdMap);
    }
    catch (err) {
        console.error(err);
    }
};
